module.exports = __webpack_public_path__ + "img/USDT-TRC20.34f55bee.png";